<template>
  <div class="landing-wrapper df fdc aifs f1 w100p">

<!--     <div class="top-bar-global w100p df jcsb aic breadcrumb-wrapper">
      <div class="breadcrumb df f1">
        <h2 class="breadcrumb-other" @click="goTo('/me')">Home</h2>
        <h2 class="breadcrumb-separator">-</h2>
        <h2>Templates</h2>
      </div>
    </div> -->

    <div class="whole-page-box-global-2 whole-page-box-global-2-bigger w100p mb0">
      <div class="title-box df">
        <h3 class="title-right">Create a template</h3>
        <h4 class="button-1" @click="newTemplate()">
            </i>New Template
        </h4>
        <!-- <p class="see-all-sessions" @click="goToTab('my-sessions')">See all</p> -->
      </div>
    </div>

    <div class="whole-page-box-global-2 whole-page-box-global-2-unset fdc w100p mb0">
      <div class="title-box df w100p jcfs">
        <h3>My Custom Templates</h3>
        <!-- <h4 class="tac curp start-new-cupping" @click="newTemplate()">
            <i class="icon far fa-plus-circle"></i>New
        </h4> -->
      </div>
      <div class="line-list w100p df fdr fww">
      <!--   <div class="line-item line-item-regular line-item-card line-item-card-1 df fdc jcsb"
              v-for="(product, i) in templates"
              v-if="!product.deleted">
              <div class="line-item line-item-header w100p df w100p jcsb popup-title-section">
                <p>{{product.name}} <span class="nobold">({{templateScore(product)}} points)</span></p>
                <i class="icon fal fa-edit curp"
                  @click="goToProduct(i)"></i>
              </div>
              <div class="step-breakdown f1 w100p">
                <div class="one-step" v-for="(step, s) in product.steps">
                  <h5>{{step.name}} ({{s + 1}} of {{product.steps.length}})</h5>
                  <div class="one-step-metrics">
                    <div class="one-step-metric" v-for="(metric, m) in step.metrics">
                      {{metric.name}}
                    </div>
                  </div>
                </div>

              </div>
        </div> -->
      </div>     
    </div>


    <div class="whole-page-box-global-2 whole-page-box-global-2-unset fdc w100p">
      <div class="title-box df w100p jcfs">
        <h3>CupWise Template Library</h3>
        <!-- <h4 class="tac curp start-new-cupping" @click="newTemplate()">
            <i class="icon far fa-plus-circle"></i>New
        </h4> -->
      </div>
      <div class="line-list w100p df fdr fww">
        <div class="line-item line-item-regular line-item-card line-item-card-1 df fdc jcsb posrel one-template"
              v-for="(product, i) in templates"
              v-if="!product.deleted"
              @click="showTemplate(i)">
              <div class="line-item line-item-header w100p df w100p jcsb popup-title-section">
                <p>{{product.name}} <span class="nobold">({{templateScore(product)}} points)</span></p>
                <img v-if="shownTemplate == i" src="../../static/images/new-icon-chevron-down.svg" class="flip-chevron">
                <img v-else src="../../static/images/new-icon-chevron-down.svg">
                <!-- <i class="icon fal fa-edit curp"
                  @click="goToProduct(i)"></i> -->
              </div>

              <div v-if="shownTemplate == i" class="step-breakdown f1 w100p">
                <div class="one-step" v-for="(step, s) in product.steps">
                  <h5>{{step.name}} ({{s + 1}} of {{product.steps.length}})</h5>
                  <div class="one-step-metrics">
                    <div class="one-step-metric" v-for="(metric, m) in step.metrics">
                      {{metric.name}}
                    </div>
                  </div>
                </div>
              </div>
        </div>
      </div>     
    </div>


  </div>
</template>

<script>

import router from '@/router'
import LandingProduct from '@/components/LandingProduct'
import templates from '@/util/tasting_templates'
import common from '@/util/common'

export default {
  name: 'Templates',
  data () {
    return {
      loading: false,
      templates: templates,
      shownTemplate: false
    }
  },
  props: ['mode'],
  components: {
    LandingProduct
  },
  methods: {
    showTemplate (i) {
      if (i === this.shownTemplate) {
        this.shownTemplate = false
      } else {
        this.shownTemplate = i
      }
    },
    templateScore (template) {
      return common.templateScore(template)
    },
    newTemplate () {
      console.log('newTemplate')
      this.goTo('/add-template')
      // v-if="($store.getters['AUTH.myPrivateData'].type == 'alpha') || ($store.getters['AUTH.myPrivateData'].type == 'pro')"
    },
    newProduct (product) {
      this.goTo('/add/' + product)
    },
    goTo (route) {
      router.push(route)
    },
    goToProduct (product) {
      let path = '/templates/' + product
      router.push(path)
    },
    productTypeDisplay (type) {
      // let type = this.productType
      if (type == 'digital-download') {
        return 'Digital Download'
      } else if (type == 'digital-service') {
        return 'Service'
      } else if (type == 'calendar-event') {
        return 'Calendar Invite'
      }
      return ''
    },
    balance () {
      let balance = 0
      let income = this.income
      for (let item in income) {
        let earned = income[item].order[0].earned ? parseFloat(income[item].order[0].earned) : parseFloat(income[item].order[0].price)
        balance = balance + earned
      } 
      return parseFloat(balance/100).toFixed(2)
    },
    formatCurrency (c) {
      return (c/100).toFixed(2)
    },
    formatDate (date) {
      console.log('date', date)
      Number.prototype.padLeft = function(base,chr){
         var  len = (String(base || 10).length - String(this).length)+1;
         return len > 0? new Array(len).join(chr || '0')+this : this;
      }

      var d = new Date(date),
      dformat = [ (d.getMonth()+1).padLeft(),
                    d.getDate().padLeft(),
                    d.getFullYear()].join('/')+
                    ' ' +
                  [ d.getHours().padLeft(),
                    d.getMinutes().padLeft()].join(':')

               return dformat
    },
  },
  computed: {
  },
  watch: {
  },
  created () {
    console.log('* Landing page created')
  }
}
</script>

<style scoped lang="scss">
  @import "../styles/settings.scss";

  .mb0 {
    margin-bottom: 20px;
  }

  .landing-wrapper {
    padding: 19px;
    padding-top: 0px;
  }
  .landing-splash, .landing-choose-your-feel {
    width: 100%;
    max-width: 720px;
  }
  .landing-products {
    flex-wrap: wrap;
    max-width: 860px;
  }
  .balance-text {
    margin-right: 10px
  }
  .balance-amount {

  }
  .income-row {
    min-width: 100px;
    margin-bottom: 10px;
    height: 32px;

    p {
      font-family: 'CA SaygonText', sans-serif;
      font-size: 14px;
      font-weight: 400;
    }

    .income-heading {
      flex: 1;
      margin-right: 20px;
      display: flex;
      align-items: center;

      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &:nth-child(1) {
        width: 15%;
        max-width: 150px;
      }
      &:nth-child(2) {
        width: 15%;
      }
      &:nth-child(3) {
        width: 10%;
        max-width: 60px;
      }
      &:nth-child(4) {
        width: 15%;
        max-width: 200px;
      }
      &:nth-child(5) {
        width: 15%;
        max-width: 120px;
      }
      &:last-child {
        margin-right: 0;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  h3 {
    color: #5469d4;
    /*width: unset !im;*/
    .icon {
      margin-right: 6px;
    }
    /*font-weight: 500 !important;*/
  }
  .icon-product {
    color: #5469d4;
  }
  .income-heading {
    .with-icon {
      align-self: center;
      justify-self: center;
      text-align: center;
    }
  }
  .icon-product {
    font-size: 24px;
  }
  .one-product {
    h3 {
      margin-left: 8px;
    }
  }
  .whole-page-box-global {
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
    padding-right: 0;
    /*cursor: pointer;*/

    &:hover {
      /*background-color: #5469d4;*/
      /*border: none;*/

      h3, .icon-product, p {
        /*color: white;*/
      }
    }

    &:last-child {
      margin-right: 0;
    }

    &:last-child {
      /*margin-bottom: 0;*/
    }
  }
  @media (max-width: 530px) {
    .whole-page-box-global {
      padding-right: 10px;
    }
  }
  .new-product-wrap {

  }
  .created {
    font-size: 14px;
    margin-left: 20px;
  }






  .start-new-cupping {
    /*padding: 7px 18px;*/
    /*position: absolute;*/
    /*top: 50%;*/
    /*transform: translateY(-50%);*/
    /*right: 0;*/
    /*border: 1px solid $color-primary;*/
    margin-left: 20px;
    border-radius: 5px;
    position: relative;

    &:hover, &:active {
      p, i {
        z-index: 2;
      }
      &::before {
        position: absolute;
        left: -6px;
        top: -6px;
        content: ' ';
        width: calc(100% + 12px);
        height: 30px;
        border: 1px solid $color-primary;
        border-radius: 5px;
        z-index: 0;
      }
    }
  }
  .line-item {
/*    p {
      &:first-child {
        flex: 1;
        width: 40%;
      }
      &:nth-last-child(4) {
        width: 62px;
        display: flex;
        & > * {
          flex: 1;
          font-size: 20px;
        }
      }
      &:nth-last-child(3) {
        margin-left: 8px;
      }
      &:nth-last-child(2) {
        width: 140px;
        margin-left: 18px;
        margin-right: 4px;
      }
      &:last-child {
        width: 25px;
        font-size: 18px;
      }
    }*/
  }
  .line-item-regular {
    cursor: pointer;
    p {
      &:nth-last-child(3) {
        font-size: 12px;
      }
      &:nth-last-child(2) {
        font-size: 13px;
      }
    }
  }
/*  @media (max-width: 640px) {
    .line-item-regular {
      height: 60px;
      flex-wrap: wrap;
      justify-content: flex-end;
      padding-top: 8px;
      padding-bottom: 6px;
      p {
        &:first-child {
          width: 100%;
          min-width: 100%;
          display: flex;
          align-items: center;
        }
      }
    }
  }
  @media (max-width: 380px) {
    .line-item-regular {
      justify-content: flex-start;
      height: unset;
      padding-top: 6px;
      padding-bottom: 6px;
      padding-right: 10px;
      p {
        width: 100%;
        margin-left: 0 !important;
        &:last-child {
          flex: 1;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }*/

/*  h3 {
    color: $color-primary;
    padding-left: 10px;
    font-weight: 600;
    font-size: 16px;
    font-family: Inter;
    font-size: 18px;
    letter-spacing: 0;
    line-height: 18px;
    .icon {
      margin-right: 6px;
    }
  }*/

  h3 {
    color: #000;
    font-family: Inter;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 20px;
    .icon {
      margin-right: 6px;
    }
  }
  /*h4 {
    color: $color-primary;
    font-weight: 500;
    font-family: Inter;
    i {
      padding-right: 10px;
    }
  }*/
  h4 {
    color: $color-primary;
    font-weight: 500;
    font-family: Inter;
    i {
      padding-right: 10px;
    }
  }
  .line-item-header {
    p {
      line-height: 1.4em;
    }
  }
  .line-list {
    padding-top: 20px;
  }
  .one-step {
    margin-bottom: 14px;
    h5 {
      margin-bottom: 2px;
    }
  }
  h5 {
    color: #000000;
    font-family: Inter;
    font-size: 13px;
    letter-spacing: 0;
    line-height: 24px;
    font-weight: 600;
  }
  .one-step-metric {
    color: #000000;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 16px;
    /*margin-bottom: 1px;*/
  }
  .step-breakdown {
    position: absolute;
    top: calc(100% - 10px);
    left: 0;
    width: 100%;
    background-color: #fafafa;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    overflow-y: auto;
    padding: 12px 12px !important;
    z-index: 1;
    border: 1px solid rgba(200, 200, 212, 0.25);
    border-top: none;

    $scrollbar-color2: grey;

    $scrollbarBG2: transparent;
    $thumbBG2: #DDD;

    &::-webkit-scrollbar {
      width: 11px;
    }
    & {
      scrollbar-width: thin;
      scrollbar-color: $thumbBG2 $scrollbarBG2;
    }
    &::-webkit-scrollbar-track {
      background: $scrollbarBG2;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 6px;
      background-color: $thumbBG2 ;
      /*border-radius: 0;*/
      /*border: 3px solid $scrollbarBG;*/
    }
  }
  @media (max-width: 420px) {
    .landing-wrapper {
      padding-left: 0;
      padding-right: 0;
    }

    .whole-page-box-global {
      border-radius: 0;
    }
  }
  .fa-edit {
    width: 25px;
    font-size: 18px;
    display: flex;
    justify-content: flex-end;
    margin-left: 10px;
  }
  .nobold {
    font-weight: 400;
  }

  .popup-title-section {
    height: 56px;
    padding: 16px 12px !important;
    border-bottom: 1px solid #DBDBDB;

    h3 {
      color: #000000;
      font-family: Inter;
      font-size: 14px;
      letter-spacing: 0;
      font-weight: 600;
      line-height: 17px;
    }
  }

  .title-right {
    margin-right: 27px;
  }

  .line-item-regular.line-item-card {
    height: unset;
  }

  .one-template {
    cursor: pointer !important;
  }

  .flip-chevron {
    transform: rotate(180deg);
  }
</style>



// WEBPACK FOOTER //
// src/pages/Templates.vue